<template>

    <div class="col-lg-7">
        <div class="card z-index-2">
            <div class="card-header pb-0">
                <h6>
                    {{ i18n["vue.component.sales-overview.title"] }}
                </h6>
                <p class="text-sm">
                    <i class="fa fa-arrow-up text-success"></i>
                    <span class="font-weight-bold">4% more</span> in 2021
                </p>
            </div>
            <div class="card-body p-3">
                <div class="chart">

                    <chart-line class="chart-canvas" :data="chartData" :options="chartOptions" height="300"/>

                </div>
            </div>
        </div>
    </div>

</template>

<script>

    // importing Vuex maps
    import { mapGetters } from "vuex";

    export default {
        name: "SalesOverviewComponent",
        components: {

            // ...

        },
        created() {

            // ...

        },
        mounted() {

            // ...

        },
        data: function () {
            return {

                // ...

            }
        },
        computed: {

            ...mapGetters({

                i18n: 'locales/getDashboardLocales'
            }),

            chartData() {

                return {

                    labels: [
                        this.i18n["vue.component.sales-overview.label.july"],
                        this.i18n["vue.component.sales-overview.label.august"],
                        this.i18n["vue.component.sales-overview.label.september"],
                        this.i18n["vue.component.sales-overview.label.october"],
                        this.i18n["vue.component.sales-overview.label.november"],
                        this.i18n["vue.component.sales-overview.label.december"],
                        this.i18n["vue.component.sales-overview.label.january"],
                        this.i18n["vue.component.sales-overview.label.february"],
                        this.i18n["vue.component.sales-overview.label.march"],
                        this.i18n["vue.component.sales-overview.label.april"],
                        this.i18n["vue.component.sales-overview.label.may"],
                        this.i18n["vue.component.sales-overview.label.june"]
                    ],
                    datasets: [
                        {
                            label: this.i18n["vue.component.sales-overview.turnover-ongoing"],
                            tension: 0.4,
                            pointRadius: 0,
                            borderColor: "#42E695",
                            borderWidth: 3,
                            backgroundColor: (ctx) => {

                                const canvas = ctx.chart.ctx;
                                const gradient = canvas.createLinearGradient(0,0,0,450);

                                gradient.addColorStop(1, 'rgba(66,230,149,0.2)');
                                gradient.addColorStop(0.2, 'rgba(72,72,176,0.0)');
                                gradient.addColorStop(0, 'rgba(203,12,159,0)');

                                return gradient;
                            },
                            fill: true,
                            maxBarThickness: 6,
                            data: [50, 40, 300, 220, 500, 250, 400, 230, 500],

                        },
                        {
                            label: this.i18n["vue.component.sales-overview.turnover-last-year"],
                            tension: 0.4,
                            pointRadius: 0,
                            borderColor: "#3A416F",
                            borderWidth: 3,
                            backgroundColor: (ctx) => {

                                const canvas = ctx.chart.ctx;
                                const gradient = canvas.createLinearGradient(0,0,0,450);

                                gradient.addColorStop(1, 'rgba(20,23,39,0.2)');
                                gradient.addColorStop(0.2, 'rgba(72,72,176,0.0)');
                                gradient.addColorStop(0, 'rgba(20,23,39,0)');

                                return gradient;
                            },
                            fill: true,
                            maxBarThickness: 6,
                            data: [30, 90, 40, 140, 290, 290, 340, 230, 400],
                        },
                    ]

                } /* mutable chart options */
            },

            chartOptions() {

                return {

                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            display: false,
                        }
                    },
                    interaction: {
                        intersect: false,
                        mode: 'index',
                    },
                    scales: {
                        y: {
                            grid: {
                                drawBorder: false,
                                display: true,
                                drawOnChartArea: true,
                                drawTicks: false,
                                borderDash: [5, 5]
                            },
                            ticks: {
                                display: true,
                                padding: 10,
                                color: '#b2b9bf',
                                font: {
                                    size: 11,
                                    family: "Open Sans",
                                    style: 'normal',
                                    lineHeight: 2
                                },
                            }
                        },
                        x: {
                            grid: {
                                drawBorder: false,
                                display: false,
                                drawOnChartArea: false,
                                drawTicks: false,
                                borderDash: [5, 5]
                            },
                            ticks: {
                                display: true,
                                color: '#b2b9bf',
                                padding: 20,
                                font: {
                                    size: 11,
                                    family: "Open Sans",
                                    style: 'normal',
                                    lineHeight: 2
                                },
                            }
                        },
                    }

                } /* mutable chart options */
            }

        },
        // watch: {
        //
        //     // ...
        //
        // },
        methods: {

            // ...

        }
    }

</script>

<style scoped lang="scss">

    // ...

</style>